const BatchPaymentsActionTypes = {
    START_IMPORT_BATCH_PAYMENT_FILE: 'START_IMPORT_BATCH_PAYMENT_FILE',
    SUCCESS_IMPORT_BATCH_PAYMENT_FILE: 'SUCCESS_IMPORT_BATCH_PAYMENT_FILE',
    FINISH_IMPORT_BATCH_PAYMENT_FILE: 'FINISH_IMPORT_BATCH_PAYMENT_FILE',
    FAILURE_IMPORT_BATCH_PAYMENT_FILE: 'FAILURE_IMPORT_BATCH_PAYMENT_FILE',

    START_EXECUTE_BATCH_PAYMENT_REQUESTS: 'START_EXECUTE_BATCH_PAYMENT_REQUESTS',
    SUCCESS_EXECUTE_BATCH_PAYMENT_REQUESTS: 'SUCCESS_EXECUTE_BATCH_PAYMENT_REQUESTS',
    FINISH_EXECUTE_BATCH_PAYMENT_REQUESTS: 'FINISH_EXECUTE_BATCH_PAYMENT_REQUESTS',
    FAILURE_EXECUTE_BATCH_PAYMENT_REQUESTS: 'FAILURE_EXECUTE_BATCH_PAYMENT_REQUESTS',

    START_CANCEL_BATCH_PAYMENT_REQUESTS: 'START_CANCEL_BATCH_PAYMENT_REQUESTS',
    SUCCESS_CANCEL_BATCH_PAYMENT_REQUESTS: 'SUCCESS_CANCEL_BATCH_PAYMENT_REQUESTS',
    FINISH_CANCEL_BATCH_PAYMENT_REQUESTS: 'FINISH_CANCEL_BATCH_PAYMENT_REQUESTS',
    FAILURE_CANCEL_BATCH_PAYMENT_REQUESTS: 'FAILURE_CANCEL_BATCH_PAYMENT_REQUESTS',

    START_GET_BATCH_PAYMENT_STATUSES: 'START_GET_BATCH_PAYMENT_STATUSES',
    SUCCESS_GET_BATCH_PAYMENT_STATUSES: 'SUCCESS_GET_BATCH_PAYMENT_STATUSES',
    FINISH_GET_BATCH_PAYMENT_STATUSES: 'FINISH_GET_BATCH_PAYMENT_STATUSES',
    FAILURE_GET_BATCH_PAYMENT_STATUSES: 'FAILURE_GET_BATCH_PAYMENT_STATUSES',

    START_GET_IMPORTED_BATCH_PAYMENTS: 'START_GET_IMPORTED_BATCH_PAYMENTS',
    SUCCESS_GET_IMPORTED_BATCH_PAYMENTS: 'SUCCESS_GET_IMPORTED_BATCH_PAYMENTS',
    FINISH_GET_IMPORTED_BATCH_PAYMENTS: 'FINISH_GET_IMPORTED_BATCH_PAYMENTS',
    FAILURE_GET_IMPORTED_BATCH_PAYMENTS: 'FAILURE_GET_IMPORTED_BATCH_PAYMENTS',

    START_GET_SINGLE_IMPORTED_BATCH_PAYMENT: 'START_GET_SINGLE_IMPORTED_BATCH_PAYMENT',
    SUCCESS_GET_SINGLE_IMPORTED_BATCH_PAYMENT: 'SUCCESS_GET_SINGLE_IMPORTED_BATCH_PAYMENT',
    FINISH_GET_SINGLE_IMPORTED_BATCH_PAYMENT: 'FINISH_GET_SINGLE_IMPORTED_BATCH_PAYMENT',
    FAILURE_GET_SINGLE_IMPORTED_BATCH_PAYMENT: 'FAILURE_GET_SINGLE_IMPORTED_BATCH_PAYMENT',

    START_GET_BATCH_PAYMENT_REQUESTS: 'START_GET_BATCH_PAYMENT_REQUESTS',
    SUCCESS_GET_BATCH_PAYMENT_REQUESTS: 'SUCCESS_GET_BATCH_PAYMENT_REQUESTS',
    FINISH_GET_BATCH_PAYMENT_REQUESTS: 'FINISH_GET_BATCH_PAYMENT_REQUESTS',
    FAILURE_GET_BATCH_PAYMENT_REQUESTS: 'FAILURE_GET_BATCH_PAYMENT_REQUESTS',
}

export default BatchPaymentsActionTypes
